/**
 * Conventions de la frise du modèle MMI.
 *
 * Le classeur projette 36 années après l'acquisition (colonnes H à AQ). Toutes les
 * séries du moteur sont des tableaux de `TIMELINE_YEARS + 1` valeurs :
 *
 *   indice 0        → t = 0, le jour de l'achat (colonne G du classeur)
 *   indice 1 à 36   → les années d'exploitation (colonnes H à AQ)
 *
 * Ce découpage reproduit celui du classeur : c'est ce qui permet de comparer le
 * moteur au classeur ligne à ligne, colonne à colonne.
 */
export const TIMELINE_YEARS = 36;
export const MONTHS_PER_YEAR = 12;
/** Une série à zéro, de la longueur d'une frise complète. */
export function zeros(length = TIMELINE_YEARS + 1) {
    return new Array(length).fill(0);
}
/**
 * Lecture d'une série qui refuse l'indice hors bornes.
 * `noUncheckedIndexedAccess` ferait sinon de chaque lecture un `number | undefined`.
 */
export function at(series, index) {
    const value = series[index];
    if (value === undefined) {
        throw new RangeError(`Indice ${index} hors de la série (longueur ${series.length})`);
    }
    return value;
}
/** Un booléen en facteur, comme Excel le fait dans `H65*(1+i)*I$124`. */
export function bit(flag) {
    return flag === true ? 1 : 0;
}
//# sourceMappingURL=series.js.map